import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const AdminRoute = ({ children }: { children: ReactElement }) => {
    const { user } = useAuth();

    return user?.roles.includes("ROLE_ADMIN") ? (
        children
    ) : (
        <Navigate to="/" replace />
    );
};

export default AdminRoute;
